var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-breadcrumb',{attrs:{"breadcrumbs":_vm.breadcrumbWithCatalog}})}
var staticRenderFns = []

export { render, staticRenderFns }